module.exports = __webpack_public_path__ + "img/T13.8bdb9074.jpg";